/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* It seems that eslint rules doesn't allow label hack for checkbox element's UI anymore */

import React, { useState } from 'react';
import css from './Toggle.module.scss';

const KEY_CODE_SPACE = 32;

const Toggle = props => {
  const { name, id, className, onChange, labelForOn, labelForOff, checked } = props;
  const [isChecked, setIsChecked] = useState(checked);

  const change = newValue => {
    setIsChecked(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleChange = value => {
    const newValue = !isChecked;
    change(newValue);
  };

  const handleKeyDown = e => {
    if (e.keyCode === KEY_CODE_SPACE) {
      e.preventDefault();
      change(!isChecked);
    }
  };

  const inputId = id || 'toggle';

  return (
    <div className={css.toggleWrapper}>
      {labelForOff ? (
        <div
          onClick={() => change(false)}
          className={css.label}
          onKeyUp={() => {}}
          role="button"
          tabIndex="0"
        >
          {labelForOff}
        </div>
      ) : null}

      <div className={css.toggle}>
        <label
          htmlFor={inputId}
          tabIndex="0"
          onKeyDown={handleKeyDown}
          role="checkbox"
          aria-checked={isChecked}
        >
          {isChecked ? (
            <div className={css.background}>
              <div className={css.switchOn} />
            </div>
          ) : (
            <div className={css.background}>
              <div className={css.switchOff} />
            </div>
          )}
        </label>
        <input
          id={inputId}
          name={name || 'toggle'}
          className={className || css.input}
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
        />
      </div>

      {labelForOn ? (
        <div
          onClick={() => change(true)}
          className={css.label}
          onKeyUp={() => {}}
          role="button"
          tabIndex="0"
        >
          {labelForOn}
        </div>
      ) : null}
    </div>
  );
};

export default Toggle;
